import api from 'service/api'

const dponetAPI = api.create('cookies', false)

const manage = async ({ bannerId, bannerTextsOverrides }) =>
  await dponetAPI.post(`/banners/${bannerId}/banner_texts_overrides`, {
    bannerTextsOverrides,
  })

export default {
  manage,
}
